import request from '@/utils/request'

// 获取菜单
export function getMenu () {
  return request({
    url: '/order/menu',
    method: 'get',
    timeout: 10000
  })
}

// 获取服务员
export function orderuser (data) {
  return request({
    url: '/order/orderuser',
    method: 'post',
    data: data
  })
}
// 获取店铺
export function selectutop (data) {
  return request({
    url: '/selectutop',
    method: 'get',
    data: data
  })
}
// 查询项目绑定跟随组
export function followGroup (data) {
  return request({
    url: '/order/followGroup',
    method: 'post',
    data
  })
}
